module.exports = __webpack_public_path__ + "e6dfd0fd9bf3d2236d97d0099705022f.png";